import { useIsCompanyPath, useIsFirmPath, useIsFundInvestmentCompanyPath, useIsFundPath } from 'utilities';
import { CompanyExcelExportDialog } from './CompanyExcelExportDialog';
import { FirmExcelExportDialog } from './FirmExcelExportDialog';
import { FundExcelExportDialog } from './FundExcelExportDialog';
import { FundInvestmentCompanyExcelExportDialog } from './FundInvestmentCompanyExcelExportDialog';
import { BaseDialogProps } from './types';

export const ExcelExportDialogV2 = (props: BaseDialogProps) => {
  const isFundInvestmentCompanyPage = useIsFundInvestmentCompanyPath();
  const isCompanyPage = useIsCompanyPath();
  const isFundPage = useIsFundPath();
  const isFirmPage = useIsFirmPath();

  if (isFundInvestmentCompanyPage) {
    return <FundInvestmentCompanyExcelExportDialog {...props} />;
  }

  if (isCompanyPage) {
    return <CompanyExcelExportDialog {...props} />;
  }

  if (isFundPage) {
    return <FundExcelExportDialog {...props} />;
  }

  if (isFirmPage) {
    return <FirmExcelExportDialog {...props} />;
  }

  return null;
};
